import baseMean from './_baseMean.js';
import identity from './identity.js';

/**
 * Computes the mean of the values in `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {number} Returns the mean.
 * @example
 *
 * _.mean([4, 2, 8, 6]);
 * // => 5
 */
function mean(array) {
  return baseMean(array, identity);
}

export default mean;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/mean.js
// module id = 706
// module chunks = 67